import * as St from '../../style';
import { icons } from '~/assets';

export type TViewMockPushMobileProps = {
  title: string;
  text: string;
};

const ViewMockPushMobile = ({
  title,
  text,
}: TViewMockPushMobileProps): JSX.Element => {
  return (
    <St.MockPhone>
      <St.MockPhoneScreen>
        <St.MockPhoneBackground src={icons.bannerTeoMock} alt="Mock banner" />

        <St.PushCard>
          <St.PushIcon src={icons.logoQuadrado} alt="Push icon" />
          <St.PushContent>
            <St.PushTitle>{title}</St.PushTitle>
            <St.PushText>{text}</St.PushText>
          </St.PushContent>
        </St.PushCard>
      </St.MockPhoneScreen>
    </St.MockPhone>
  );
};

export default ViewMockPushMobile;
